/**
 * Identifiers.
 *
 * Ids are generated on the client because ink must appear before the network is
 * involved (docs/03-ARCHITECTURE.md §7.2). They therefore have to be unique without
 * coordination, which is what a random 128-bit value gives us.
 */
/** Ten random bytes as twenty hex characters. */
function randomHex() {
    const bytes = new Uint8Array(10);
    globalThis.crypto.getRandomValues(bytes);
    let hex = '';
    for (const byte of bytes)
        hex += byte.toString(16).padStart(2, '0');
    return hex;
}
/**
 * A random id, prefixed so it is obvious what a stray id belongs to in a log.
 *
 * Built from `getRandomValues` rather than `randomUUID`, because `randomUUID` only
 * exists on https and on localhost. A student joining from a phone over the classroom
 * network is on plain http, and there every id — every stroke — would otherwise fail
 * to be created at all.
 */
export function createId(prefix) {
    return `${prefix}_${randomHex()}`;
}
export const newStrokeId = () => createId('stk');
export const newObjectId = () => createId('obj');
export const newPageId = () => createId('pg');
export const newBadgeId = () => createId('bdg');
/**
 * Lowercased and trimmed display name, used to recognise a student who rejoins under
 * the same name so they are counted once (docs/05-DATA-MODEL.md §2.6.1).
 */
export function normaliseName(displayName) {
    return displayName.trim().toLowerCase().replace(/\s+/g, ' ');
}
//# sourceMappingURL=ids.js.map